export default __webpack_public_path__ + "static/media/addIcon.27a64e94.svg";